import { useQuery } from '@tanstack/react-query';
import { reviewsApi } from '../../../api/reviews';

const apiMap = {
  releases: {
    all: reviewsApi.getNewReleases,
    albums: reviewsApi.getNewAlbums,
    singles: reviewsApi.getNewSingles,
  },
  recommended: {
    all: reviewsApi.getRecommend,
    albums: reviewsApi.getRecommendAlbums,
    singles: reviewsApi.getRecommendSingles,
  },
  recent: {
    all: reviewsApi.getRecentReviews,
    albums: reviewsApi.getRecentReviewsAlbums,
    singles: reviewsApi.getRecentReviewsSingles,
  },
  popular: {
    all: reviewsApi.getPopularReviews,
    albums: reviewsApi.getRecentReviewsAlbums,
    singles: reviewsApi.getRecentReviewsSingles,
  },
  korean: {
    albums: reviewsApi.getKoreanMusicAlbums,
    singles: reviewsApi.getKoreanMusicSingles,
  },
  global: {
    albums: reviewsApi.getGlobalMusicAlbums,
    singles: reviewsApi.getGlobalMusicSingles,
  },
};

export const useReviewsAlbums = ({ region, category, type, sort, page, size, period }) =>
  useQuery({
    queryKey: ['reviewsAlbums', region, category, type, sort, page, size, period],
    queryFn: () => {
      const apiFn = apiMap[category]?.[type] || apiMap.releases.albums;
      return apiFn(sort, page, size, period, region);
    },
    select: (res) => ({
      albums: res.data,
      pagination: res.meta?.pagination ?? { currentPage: 1, totalPages: 1, totalItems: 0 },
    }),
    staleTime: 5 * 60 * 1000,
  });
